
  import ipxRuntime$RxGHTUpjRPGYSNcRA_empMI0tCu0XtKjRF6d2uRSxkc from '/vercel/path0/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@62998ab_@vercel+blob@2.0.0_aws4fetch@1.0.20__6ad479b52c49d087ebeb2174ffd6a71e/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$RxGHTUpjRPGYSNcRA_empMI0tCu0XtKjRF6d2uRSxkc, defaults: {"baseURL":"https://ipx.nuxt.com"} }
    }
  }
